<mat-sidenav-container>
    <mat-sidenav-content>
        <mat-card class="mat-card-class" [ngClass]="{'linkageStyles':linkageCardWebElement.cardDeckType === DeckType.linkage, 'lockStyles': elementLock !== null && linkageCardWebElement.linkageSourceIds.includes(elementLock.linkObject.sourceId) && linkageCardWebElement.linkageTargetIds.includes(elementLock.linkObject.targetId)}">
            <div class="card_pattern_frontside">
                <div *ngIf="cardPattern$ | async as cardPattern" class="card_cell_direction card_cell_direction_redux_left" role="button" id="sideMenuButton"
                    (click)="openSideMenu('left')"
                    [routerLink]="[{ outlets: { sideMenu: ['side-menu']}}]"
                    emRecommendationIndicator [cells]="cardPattern.cardCells" [cardDeckId]="cardPattern.cardDeckId"
                    [deckType]="cardPattern.cardDeckType" [patternId]="cardPattern.id"></div>
                <!--div style="position:absolute; top: 40pt">{{this.linkageCardWebElement.id}}</div-->
                <svg width="253" height="401">
                    <!-- border-up-middle-->
                    <path *ngIf="this.canHaveBorder('up', LinkageDirection.middle)"
                            d="M 102 0 L 155 0"
                            stroke="#dddddd" stroke-width="25" fill="none"
                    />
                    <!-- border-up-left-->
                    <path *ngIf="this.canHaveBorder('up', LinkageDirection.left)"
                            d="M 0 72 L 0 108"
                            stroke="#dddddd" stroke-width="40" fill="none"
                    />
                    <!-- border-up-right-->
                    <path *ngIf="this.canHaveBorder('up', LinkageDirection.right)"
                            d="M 253 72 L 253 108"
                            stroke="#dddddd" stroke-width="40" fill="none"
                    />
                    <!-- border-down-middle-->
                    <path *ngIf="this.canHaveBorder('down', LinkageDirection.middle)"
                            d="M 102 401 L 155 401"
                            stroke="#dddddd" stroke-width="25" fill="none"
                    />
                    <!-- border-down-left-->
                    <path *ngIf="this.canHaveBorder('down', LinkageDirection.left)"
                            d="M 0 322 L 0 358"
                            stroke="#dddddd" stroke-width="40" fill="none"
                    />
                    <!-- border-down-right-->
                    <path *ngIf="this.canHaveBorder('down', LinkageDirection.right)"
                          d="M 253 322 L 253 358"
                          stroke="#dddddd" stroke-width="40" fill="none"
                    />
                    <!-- arc-down-right-->
                    <path *ngIf="this.linkageCardWebElement.linkageDownRightDirection"
                        d="M 129 200 A 101 140 0 0 0 230 340"
                        stroke="#bbbbbb" stroke-width="30" fill="none"
                    />
                    <!-- arc-down-left-->
                    <path *ngIf="this.linkageCardWebElement.linkageDownLeftDirection"
                        d="M 129 200 A 106 140 0 0 1 23 340"
                        stroke="#bbbbbb" stroke-width="30" fill="none"
                    />
                    <!-- arc-down-middle-->
                    <path *ngIf="this.linkageCardWebElement.linkageDownMiddleDirection"
                            d="M 129 200 L 129 385"
                            stroke="#bbbbbb" stroke-width="30" fill="none"
                    />
                    <!-- arc-up-right-->
                    <path *ngIf="this.linkageCardWebElement.linkageUpRightDirection"
                            d="M 129 200 A 96 110 0 0 1 225 90"
                            stroke="#bbbbbb" stroke-width="30" fill="none"
                    />
                    <!-- arc-up-left-->
                    <path *ngIf="this.linkageCardWebElement.linkageUpLeftDirection"
                            d="M 129 200 A 101 110 0 0 0 28 90"
                            stroke="#bbbbbb" stroke-width="30" fill="none"
                    />

                    <!-- arc-up-middle-->
                    <path *ngIf="this.linkageCardWebElement.linkageUpMiddleDirection"
                            d="M 129 200 L 129 16"
                            stroke="#bbbbbb" stroke-width="30" fill="none"
                    />
                </svg>
            </div>
        </mat-card>
    </mat-sidenav-content>
</mat-sidenav-container>
<ng-template #loading>
    <div style="color:#999999">Karte wird geladen...</div>
</ng-template>

